module.exports = __webpack_public_path__ + "img/curious.49cb03d6.svg";